import { render, staticRenderFns } from "./timeline.vue?vue&type=template&id=c6570014&scoped=true&"
import script from "./timeline.vue?vue&type=script&lang=js&"
export * from "./timeline.vue?vue&type=script&lang=js&"
import style0 from "./timeline.vue?vue&type=style&index=0&id=c6570014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6570014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6570014')) {
      api.createRecord('c6570014', component.options)
    } else {
      api.reload('c6570014', component.options)
    }
    module.hot.accept("./timeline.vue?vue&type=template&id=c6570014&scoped=true&", function () {
      api.rerender('c6570014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/components/timeline.vue"
export default component.exports